import { BiPixel } from '@derstandard/tracking';
import { getEdition } from './utils';
import { v4 as uuid } from '@lukeed/uuid';

window.cX = window.cX || {};
window.cX.callQueue = window.cX.callQueue || [];

type TrackingOption = {
	dmp: boolean;
};

export const biPixel = new BiPixel({
	pixelUrl: import.meta.env.VITE_BI_PIXEL_URL,
	receiverUrl: getEdition() === 'de' ? import.meta.env.VITE_BI_RECEIVER_URL_DE : import.meta.env.VITE_BI_RECEIVER_URL_AT,

	// this is a special environment variable that is set by Vite
	environment: import.meta.env.MODE,
});

export function trackUserAction(userAction: keyof typeof settings) {
	const correlationId = uuid();
	const userActionOption = settings[userAction] as TrackingOption;

	// BI Pixel Page Impression
	biPixel.sendPageImpression({
		action: userAction,
		correlationid: correlationId,
	});

	// Piano DMP Performance Event
	if (userActionOption.dmp) {
		window.cX.callQueue.push(['sendEvent', 'readlater', { action: userAction }]);
	}
}

const settings = {
	// Leseliste (Inhalt hinzufügen), Inhalt zur Leseliste hinzugefügt (auf Artikel- und Übersichtsseiten)
	readlater_add_article: { dmp: true },
	// Leseliste (Inhalt entfernen), Inhalt von Leseliste entfernt (auf Artikel- und Übersichtsseiten)
	readlater_remove_article: { dmp: true },
	// Leseliste (Gelesene Inhalte entfernen), Alle gelesenen Einträge entfernt
	readlater_remove_read: { dmp: true },
	// Leseliste (Alle Inhalte entfernen), Alle Einträge entfernt
	readlater_remove_all: { dmp: true },
	// Leseliste (Einen Inhalt von der Liste entfernen), Inhalt aus Leseliste gelöscht
	readlater_delete_item: { dmp: true },
	// Leseliste (Liste öffnen), Leseliste geöffnet
	readlater_list_open: { dmp: true },
	// Leseliste (Liste mit Keyboard öffnen), Leseliste via Keyboard-Shortcut geöffnet
	readlater_list_open_kb: { dmp: true },
	// Leseliste (Inhalt hinzufügen verboten), Error 402, Backend hat das hinzufügen aufgrund von fehlenden Berechtigungen verweigert
	readlater_add_prohibited: { dmp: true },
} as const;
